// import React, { useState, useEffect, useRef } from "react";

// const people = [
//   { name: "Jismaya Exterior", role: "Architectural Project", img: "/gallery/1.jpeg" },
//   { name: "Jismaya Interior", role: "Interior Design Project", img: "/gallery/2.jpeg" },
//   { name: "Modern Exterior", role: "3D Elevation Design", img: "/gallery/3.PNG" },
//   { name: "Modern House", role: "Exterior Visualization", img: "/gallery/4.PNG" },
//   { name: "Residential Villa", role: "Architectural Design", img: "/gallery/5.jpeg" },
//   { name: "Luxury House", role: "Exterior Render", img: "/gallery/6.png" },
//   { name: "Classic Home", role: "Exterior Design", img: "/gallery/7.PNG" },
//   { name: "Interior Hall", role: "Living Room Design", img: "/gallery/8.jpeg" },
//   { name: "Modern Interior", role: "Room Visualization", img: "/gallery/9.png" },
//   { name: "Mechanical Parts", role: "CAD Design", img: "/gallery/10.png" },
//   { name: "Engine Assembly", role: "Mechanical Project", img: "/gallery/11.png" },
//   { name: "Container House", role: "Architecture Concept", img: "/gallery/12.png" },
//   { name: "Kitchen Interior", role: "Interior Design", img: "/gallery/13.jpeg" },
//   { name: "Modern Kitchen", role: "Interior Visualization", img: "/gallery/14.jpeg" },
//   { name: "Bedroom Design", role: "Interior Project", img: "/gallery/15.jpeg" },
//   { name: "Living Interior", role: "Interior Design", img: "/gallery/16.jpeg" },
//   { name: "Luxury Bedroom", role: "Interior Visualization", img: "/gallery/17.jpeg" },
//   { name: "Minimal Bedroom", role: "Room Design", img: "/gallery/18.jpeg" },
//   { name: "Dining Area", role: "Interior Space", img: "/gallery/19.jpeg" },
//   { name: "Modern Living", role: "Interior Render", img: "/gallery/20.jpeg" },
//   { name: "Outdoor Space", role: "Exterior Design", img: "/gallery/21.jpeg" },
//   { name: "Villa Exterior", role: "Architecture Render", img: "/gallery/22.png" },
//   { name: "Dark Interior", role: "Room Visualization", img: "/gallery/23.png" },
//   { name: "Small House", role: "Exterior Concept", img: "/gallery/24.png" },
//   { name: "Traditional House", role: "Architecture Design", img: "/gallery/25.png" },
//   { name: "Glass Interior", role: "Modern Interior", img: "/gallery/26.jpeg" },
//   { name: "Landscape Design", role: "Outdoor Planning", img: "/gallery/27.png" },
//   { name: "Empty Room", role: "Interior Base Design", img: "/gallery/28.jpeg" },
//   { name: "Wood Interior", role: "Luxury Interior", img: "/gallery/29.jpeg" }
// ];
// export default function GalerySlider() {
//   const [current, setCurrent] = useState(2);
//   const [dragging, setDragging] = useState(false);
//   const dragStartX = useRef(null);
//   const intervalRef = useRef(null);

//   const goTo = (i) => {
//     const n = people.length;
//     setCurrent(((i % n) + n) % n);
//   };

//   // Auto-play
//   useEffect(() => {
//     intervalRef.current = setInterval(() => {
//       setCurrent((prev) => (prev + 1) % people.length);
//     }, 3500);
//     return () => clearInterval(intervalRef.current);
//   }, []);

//   // Mouse drag handlers
//   const handleMouseDown = (e) => {
//     dragStartX.current = e.clientX;
//     setDragging(false);
//   };

//   const handleMouseMove = (e) => {
//     if (dragStartX.current !== null) setDragging(true);
//   };

//   const handleMouseUp = (e) => {
//     if (dragStartX.current === null) return;
//     const diff = e.clientX - dragStartX.current;
//     if (Math.abs(diff) > 40) {
//       diff < 0 ? goTo(current + 1) : goTo(current - 1);
//     }
//     dragStartX.current = null;
//     setTimeout(() => setDragging(false), 50);
//   };

//   // Touch handlers
//   const handleTouchStart = (e) => {
//     dragStartX.current = e.touches[0].clientX;
//   };

//   const handleTouchEnd = (e) => {
//     if (dragStartX.current === null) return;
//     const diff = e.changedTouches[0].clientX - dragStartX.current;
//     if (Math.abs(diff) > 40) {
//       diff < 0 ? goTo(current + 1) : goTo(current - 1);
//     }
//     dragStartX.current = null;
//   };

//   const getCardStyle = (offset) => {
//     const absOff = Math.abs(offset);
//     if (offset === 0) {
//       return {
//         transform: `translateX(0px) scale(1) perspective(900px) rotateY(0deg)`,
//         zIndex: 10,
//         filter: "brightness(1)",
//         cursor: "default",
//       };
//     }
//     const dir = offset > 0 ? 1 : -1;
//     const translateX = dir * (120 + (absOff - 1) * 90);
//     const scale = Math.max(0.52, 0.70 - (absOff - 1) * 0.08);
//     const rotateY = dir * (65 + (absOff - 1) * 8);
//     const brightness = Math.max(0.35, 0.62 - (absOff - 1) * 0.1);
//     return {
//       transform: `translateX(${translateX}px) scale(${scale}) perspective(900px) rotateY(${rotateY}deg)`,
//       zIndex: 10 - absOff,
//       filter: `brightness(${brightness})`,
//       cursor: "pointer",
//     };
//   };

//   return (
//     <div
//       style={styles.root}
//       onMouseDown={handleMouseDown}
//       onMouseMove={handleMouseMove}
//       onMouseUp={handleMouseUp}
//       onMouseLeave={() => { dragStartX.current = null; }}
//       onTouchStart={handleTouchStart}
//       onTouchEnd={handleTouchEnd}
//     >
//       {/* Prev Button */}
//       <button
//         style={{ ...styles.navBtn, left: "16px" }}
//         onClick={() => goTo(current - 1)}
//       >
//         &#8249;
//       </button>

//       {/* Next Button */}
//       <button
//         style={{ ...styles.navBtn, right: "16px" }}
//         onClick={() => goTo(current + 1)}
//       >
//         &#8250;
//       </button>

//       {/* Stage */}
//       <div style={styles.stage}>
//         {people.map((p, i) => {
//           const offset = i - current;
//           const absOff = Math.abs(offset);
//           if (absOff > 3) return null;

//           return (
//             <div
//               key={i}
//               style={{ ...styles.card, ...getCardStyle(offset) }}
//               onClick={() => { if (!dragging && offset !== 0) goTo(i); }}
//             >
//               <img src={p.img} alt={p.name} style={styles.img} />

//               {/* Active card — name + role only, no play button */}
//               {offset === 0 && (
//                 <div style={styles.cardLabel}>
//                   <span style={styles.cardName}>{p.name}</span>
//                   <span style={styles.cardRole}>{p.role}</span>
//                 </div>
//               )}

//               {/* Side cards — vertical name */}
//               {offset !== 0 && (
//                 <div style={styles.sideLabel}>
//                   <span style={styles.sideName}>{p.name}</span>
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>

//       {/* Dots */}
//       <div style={styles.dots}>
//         {people.map((_, i) => (
//           <div
//             key={i}
//             onClick={() => goTo(i)}
//             style={{
//               ...styles.dot,
//               background: i === current ? "rgba(0,0,0,0.65)" : "rgba(0,0,0,0.2)",
//               transform: i === current ? "scale(1.4)" : "scale(1)",
//             }}
//           />
//         ))}
//       </div>

//     </div>
//   );
// }

// const styles = {
//   root: {
//     width: "100%",
//     minHeight: "600px",
//     background: "linear-gradient(160deg, #b8d8e8 0%, #d4e8d8 50%, #e8d4c8 100%)",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "40px 0 30px",
//     overflow: "hidden",
//     position: "relative",
//     // borderRadius: "16px",
//     userSelect: "none",
//   },
//   stage: {
//     position: "relative",
//     width: "100%",
//     height: "440px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   card: {
//     position: "absolute",
//     width: "320px",       // wider
//     height: "400px",      // taller
//     borderRadius: "15px",
//     overflow: "hidden",
//     transition: "all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
//     transformOrigin: "center center",
//   },
//   img: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//     pointerEvents: "none",
//   },
//   cardLabel: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     right: 0,
//     padding: "28px 16px 18px",
//     background: "linear-gradient(to top, rgba(0,0,0,0.88) 0%, transparent 100%)",
//     display: "flex",
//     flexDirection: "column",
//     gap: "4px",
//   },
//   cardName: {
//     fontFamily: "sans-serif",
//     fontSize: "15px",
//     fontWeight: "700",
//     color: "#fff",
//     letterSpacing: "0.1em",
//     textTransform: "uppercase",
//   },
//   cardRole: {
//     fontFamily: "sans-serif",
//     fontSize: "10px",
//     color: "rgba(255,255,255,0.7)",
//     letterSpacing: "0.14em",
//     textTransform: "uppercase",
//   },
//   sideLabel: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     pointerEvents: "none",
//     background: "rgba(0,0,0,0.15)",
//   },
//   sideName: {
//     fontFamily: "sans-serif",
//     fontSize: "12px",
//     fontWeight: "700",
//     color: "rgba(255,255,255,0.95)",
//     letterSpacing: "0.2em",
//     textTransform: "uppercase",
//     writingMode: "vertical-rl",
//     textOrientation: "mixed",
//   },
//   navBtn: {
//     position: "absolute",
//     top: "50%",
//     transform: "translateY(-50%)",
//     background: "rgba(255,255,255,0.35)",
//     border: "none",
//     borderRadius: "50%",
//     width: "42px",
//     height: "42px",
//     fontSize: "26px",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 100,
//     color: "#333",
//     transition: "background 0.2s",
//   },
//   dots: {
//     display: "flex",
//     gap: "8px",
//     marginTop: "24px",
//   },
//   dot: {
//     width: "7px",
//     height: "7px",
//     borderRadius: "50%",
//     cursor: "pointer",
//     transition: "all 0.3s",
//   },
// };



import React, { useState, useEffect, useRef } from "react";

const people = [
  { name: "Jismaya Exterior", role: "Architectural Project", img: "/gallery/1.webp" },
  { name: "Jismaya Interior", role: "Interior Design Project", img: "/gallery/2.webp" },
  { name: "Modern Exterior", role: "3D Elevation Design", img: "/gallery/3.webp" },
  { name: "Modern House", role: "Exterior Visualization", img: "/gallery/4.webp" },
  { name: "Residential Villa", role: "Architectural Design", img: "/gallery/5.webp" },
  { name: "Luxury House", role: "Exterior Render", img: "/gallery/6.webp" },
  { name: "Classic Home", role: "Exterior Design", img: "/gallery/7.webp" },
  { name: "Interior Hall", role: "Living Room Design", img: "/gallery/8.webp" },
  { name: "Modern Interior", role: "Room Visualization", img: "/gallery/9.webp" },
  { name: "Mechanical Parts", role: "CAD Design", img: "/gallery/10.webp" },
  { name: "Engine Assembly", role: "Mechanical Project", img: "/gallery/11.webp" },
  { name: "Container House", role: "Architecture Concept", img: "/gallery/12.webp" },
  { name: "Kitchen Interior", role: "Interior Design", img: "/gallery/13.webp" },
  { name: "Modern Kitchen", role: "Interior Visualization", img: "/gallery/14.webp" },
  { name: "Bedroom Design", role: "Interior Project", img: "/gallery/15.webp" },
  { name: "Living Interior", role: "Interior Design", img: "/gallery/16.webp" },
  { name: "Luxury Bedroom", role: "Interior Visualization", img: "/gallery/17.webp" },
  { name: "Minimal Bedroom", role: "Room Design", img: "/gallery/18.webp" },
  { name: "Dining Area", role: "Interior Space", img: "/gallery/19.webp" },
  { name: "Modern Living", role: "Interior Render", img: "/gallery/20.webp" },
  { name: "Outdoor Space", role: "Exterior Design", img: "/gallery/21.webp" },
  { name: "Villa Exterior", role: "Architecture Render", img: "/gallery/22.webp" },
  { name: "Dark Interior", role: "Room Visualization", img: "/gallery/23.webp" },
  { name: "Small House", role: "Exterior Concept", img: "/gallery/24.webp" },
  { name: "Traditional House", role: "Architecture Design", img: "/gallery/25.webp" },
  { name: "Glass Interior", role: "Modern Interior", img: "/gallery/26.webp" },
  { name: "Landscape Design", role: "Outdoor Planning", img: "/gallery/27.webp" },
  { name: "Empty Room", role: "Interior Base Design", img: "/gallery/28.webp" },
  { name: "Wood Interior", role: "Luxury Interior", img: "/gallery/29.webp" }
];
export default function GalerySlider() {
  const [current, setCurrent] = useState(2);
  const [dragging, setDragging] = useState(false);
  const dragStartX = useRef(null);
  const intervalRef = useRef(null);

  const goTo = (i) => {
    const n = people.length;
    setCurrent(((i % n) + n) % n);
  };

  // Auto-play
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % people.length);
    }, 3500);
    return () => clearInterval(intervalRef.current);
  }, []);

  // Mouse drag handlers
  const handleMouseDown = (e) => {
    dragStartX.current = e.clientX;
    setDragging(false);
  };

  const handleMouseMove = (e) => {
    if (dragStartX.current !== null) setDragging(true);
  };

  const handleMouseUp = (e) => {
    if (dragStartX.current === null) return;
    const diff = e.clientX - dragStartX.current;
    if (Math.abs(diff) > 40) {
      diff < 0 ? goTo(current + 1) : goTo(current - 1);
    }
    dragStartX.current = null;
    setTimeout(() => setDragging(false), 50);
  };

  // Touch handlers
  const handleTouchStart = (e) => {
    dragStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (dragStartX.current === null) return;
    const diff = e.changedTouches[0].clientX - dragStartX.current;
    if (Math.abs(diff) > 40) {
      diff < 0 ? goTo(current + 1) : goTo(current - 1);
    }
    dragStartX.current = null;
  };

  const getCardStyle = (offset) => {
    const absOff = Math.abs(offset);
    if (offset === 0) {
      return {
        transform: `translateX(0px) scale(1) perspective(900px) rotateY(0deg)`,
        zIndex: 10,
        filter: "brightness(1)",
        cursor: "default",
      };
    }
    const dir = offset > 0 ? 1 : -1;
    const translateX = dir * (120 + (absOff - 1) * 90);
    const scale = Math.max(0.52, 0.70 - (absOff - 1) * 0.08);
    const rotateY = dir * (65 + (absOff - 1) * 8);
    const brightness = Math.max(0.35, 0.62 - (absOff - 1) * 0.1);
    return {
      transform: `translateX(${translateX}px) scale(${scale}) perspective(900px) rotateY(${rotateY}deg)`,
      zIndex: 10 - absOff,
      filter: `brightness(${brightness})`,
      cursor: "pointer",
    };
  };

  return (
    <div
      style={styles.root}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={() => { dragStartX.current = null; }}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {/* Prev Button */}
      <button
        style={{ ...styles.navBtn, left: "16px" }}
        onClick={() => goTo(current - 1)}
      >
        &#8249;
      </button>

      {/* Next Button */}
      <button
        style={{ ...styles.navBtn, right: "16px" }}
        onClick={() => goTo(current + 1)}
      >
        &#8250;
      </button>

      {/* Stage */}
      <div style={styles.stage}>
        {people.map((p, i) => {
          const offset = i - current;
          const absOff = Math.abs(offset);
          if (absOff > 3) return null;

          return (
            <div
              key={i}
              style={{ ...styles.card, ...getCardStyle(offset) }}
              onClick={() => { if (!dragging && offset !== 0) goTo(i); }}
            >
              <img
  src={p.img}
  alt={p.name}
  style={styles.img}
  loading={offset === 0 ? "eager" : "lazy"}
  fetchpriority={offset === 0 ? "high" : "low"}
  decoding="async"
/>
              {/* Active card — name + role only, no play button */}
              {offset === 0 && (
                <div style={styles.cardLabel}>
                  <span style={styles.cardName}>{p.name}</span>
                  <span style={styles.cardRole}>{p.role}</span>
                </div>
              )}

              {/* Side cards — vertical name */}
              {offset !== 0 && (
                <div style={styles.sideLabel}>
                  <span style={styles.sideName}>{p.name}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Dots */}
      <div style={styles.dots}>
        {people.map((_, i) => (
          <div
            key={i}
            onClick={() => goTo(i)}
            style={{
              ...styles.dot,
              background: i === current ? "rgba(0,0,0,0.65)" : "rgba(0,0,0,0.2)",
              transform: i === current ? "scale(1.4)" : "scale(1)",
            }}
          />
        ))}
      </div>

    </div>
  );
}

const styles = {
  root: {
    width: "100%",
    minHeight: "600px",
    background: "linear-gradient(160deg, #b8d8e8 0%, #d4e8d8 50%, #e8d4c8 100%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 0 30px",
    overflow: "hidden",
    position: "relative",
    // borderRadius: "16px",
    userSelect: "none",
  },
  stage: {
    position: "relative",
    width: "100%",
    height: "440px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  card: {
    position: "absolute",
    width: "320px",       // wider
    height: "400px",      // taller
    borderRadius: "15px",
    overflow: "hidden",
    transition: "all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    transformOrigin: "center center",
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    pointerEvents: "none",
  },
  cardLabel: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "28px 16px 18px",
    background: "linear-gradient(to top, rgba(0,0,0,0.88) 0%, transparent 100%)",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  cardName: {
    fontFamily: "sans-serif",
    fontSize: "15px",
    fontWeight: "700",
    color: "#fff",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
  cardRole: {
    fontFamily: "sans-serif",
    fontSize: "10px",
    color: "rgba(255,255,255,0.7)",
    letterSpacing: "0.14em",
    textTransform: "uppercase",
  },
  sideLabel: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    background: "rgba(0,0,0,0.15)",
  },
  sideName: {
    fontFamily: "sans-serif",
    fontSize: "12px",
    fontWeight: "700",
    color: "rgba(255,255,255,0.95)",
    letterSpacing: "0.2em",
    textTransform: "uppercase",
    writingMode: "vertical-rl",
    textOrientation: "mixed",
  },
  navBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(255,255,255,0.35)",
    border: "none",
    borderRadius: "50%",
    width: "42px",
    height: "42px",
    fontSize: "26px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
    color: "#333",
    transition: "background 0.2s",
  },
  dots: {
    display: "flex",
    gap: "8px",
    marginTop: "24px",
  },
  dot: {
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    cursor: "pointer",
    transition: "all 0.3s",
  },
};